(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/hooks/use-observe-settings.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/hooks/use-observe-settings.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect,
  useContext = _React.useContext;
const _svs$components$tipse = svs.components.tipsen.selectors,
  selectShowCompressedCoupon = _svs$components$tipse.selectShowCompressedCoupon,
  selectOutcomeInfoChoise = _svs$components$tipse.selectOutcomeInfoChoise;
const setOutcomeInfoChoises = svs.components.tipsen.store.actions.couponSettingsActions.setOutcomeInfoChoises;
const selectModuleName = svs.components.tipsen.engine.selectors.engineSelectors.selectModuleName;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const TipsinfoTypes = svs.components.tipsen.engine.constants.TipsinfoTypes;
const RenderContext = svs.component.tipsen.renderContext.RenderContext;
const useObserveSettings = () => {
  const _useContext = useContext(RenderContext),
    pageType = _useContext.pageType;
  const dispatch = useDispatch();
  const moduleName = useSelector(selectModuleName);
  const outcomeInfoChoises = useSelector(state => selectOutcomeInfoChoise(state, pageType));
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const showCompressedCoupon = useSelector(selectShowCompressedCoupon);
  useEffect(() => {
    if (isExtraSmall && showCompressedCoupon && outcomeInfoChoises.display === TipsinfoTypes.SvenskaFolket) {
      dispatch(setOutcomeInfoChoises({
        moduleName,
        changes: [{
          field: 'display',
          state: TipsinfoTypes.OutcomeLabel
        }]
      }));
    }
  }, [isExtraSmall, moduleName, showCompressedCoupon, outcomeInfoChoises, dispatch]);
  return null;
};
setGlobal('svs.components.tipsen.coupon.hooks.useObserveSettings', useObserveSettings);

 })(window);